import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    message: {
      hello: 'hello world'
    },
    common: {
      usdt: 'USDT',
      eqx: 'EQX',
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: 'Copy failed',
      done: 'Done',
      stayTuned: 'Stay tuned',
      txHash: 'Transaction Hash',
      txHashEmpty: 'Transaction hash is empty',
      installWallet: 'Please install or enable your wallet extension',
      walletNotConnected: 'Wallet not connected',
      txFailed: 'Transaction failed',
      txTimeout: 'Transaction confirmation timed out',
      decimalsInvalid: 'Invalid decimals',
      pleaseLogin: 'Please log in first',
      accountBanned: 'Account banned',
      back: 'Back',
      confirm: 'Confirm'
    },
    hashPower: {
      globalLabel: 'Global Hash Power',
      myLabel: 'My Hash Power',
      stats: {
        nodeCount: 'Node Count',
        todayYield: 'Today Yield',
        totalStaked: 'Total Staked',
        directPool: 'Direct Ranking Pool',
        simGoldPool: 'Sim Gold Pool'
      }
    },
    home: {
      participateNow: 'Buy Computing Power',
      participatedQuota: 'Participated',
      walletAvailable: 'Wallet Available',
      remainingQuota: 'Remaining Quota',
      participateAmount: 'Amount',
      amountRange: '100-10000 USDT',
      maxTitle: 'You have reached the maximum participation quota',
      maxDesc: 'When participation reaches 10000U, you cannot participate again',
      participateSuccessTitle: 'Participation Successful',
      participateSuccessSubtitle: 'Transaction confirmed on-chain',
      confirmDone: 'Confirm',
      amountMultiple100: 'Amount must be a multiple of 100',
      participateFailed: 'Participation failed',
      userInfoFailed: 'Failed to fetch user info'
    },
    my: {
      nodeTorch: 'Torch Node',
      nodeGlory: 'Glory Node',
      totalClaimedUsdt: 'Total Claimed USDT',
      remainingExitQuotaUsdt: 'Remaining Exit Quota USDT',
      totalClaimedEqx: 'Total Claimed EQX',
      unclaimedUsdt: 'Unclaimed USDT',
      unclaimedEqx: 'Unclaimed EQX',
      claim: 'Claim',
      copyInviteLink: 'Copy Invite Link',
      receivingAddress: 'Receiving Address',
      claimAmount: 'Claim Amount',
      confirmClaim: 'Confirm Claim',
      claimSuccessTitle: 'Claim Successful',
      claimArrived: '{amount} {token} has arrived',
      totalDataFailed: 'Failed to fetch statistics',
      requestSignFailed: 'Failed to request signature',
      signMissing: 'Signature missing from server response',
      signInvalid: 'Invalid signature format',
      noClaimUsdt: 'No claimable USDT',
      noClaimEqx: 'No claimable EQX',
      eqxPoolTransferable: 'Transferable to Pool',
      eqxPoolNextDeposit: 'Next Earliest Deposit',
      eqxPoolDeposit: 'Deposit to Pool',
      eqxPoolSection: 'EQX Pool',
      eqxPoolClaimable: 'Claimable Now',
      eqxPoolUnreleased: 'Pending Release',
      eqxPoolReleasePerDay: 'Daily Release',
      eqxPoolFinalTime: 'Est. Completion',
      eqxPoolClaimReleased: 'Claim Released EQX',
      eqxSwitchChain: 'Please switch wallet to BSC network',
      eqxPoolDataError: 'Invalid pool data returned',
      eqxPoolPaused: 'Claim paused',
      eqxPoolNothing: 'No claimable EQX',
      eqxPoolAutoCheckpoint: 'Claim transaction will advance release milestones automatically',
      claimFailed: 'Claim failed'
    },
    navbar: {
      connectWallet: 'Connect Wallet',
      connectFailed: 'Failed to connect wallet',
      nonceFailed: 'Failed to get nonce',
      loginFailed: 'Login failed',
      signLoginFailed: 'Signature or login failed',
      userInfoFailed: 'Failed to fetch user info',
      langEn: 'English',
      langZh: '中文',
      langKo: '한국어',
      langJa: '日本語'
    },
    tab: {
      home: 'Home',
      sim: 'Sim',
      my: 'Me'
    },
    modal: {
      invite: {
        title: 'Enter Invite Code',
        placeholder: 'Please enter the invitation code',
        formatHint: 'Format: 6–12 alphanumeric characters',
        invalidFormat: 'Format: 6–12 alphanumeric characters',
        cancel: 'Cancel',
        confirm: 'Confirm',
        noCodeHint: 'No invite code? Contact your referrer',
        required: 'Invite code is required'
      }
    },
    community: {
      title: 'Community Performance',
      macroTitle: 'Macro Performance',
      microTitle: 'Micro Performance',
      totalCount: 'Total Count',
      totalAmount: 'Total Amount',
      communityUsers: 'Community Users',
      activeNodes: 'Active Nodes',
      fetchFailed: 'Failed to fetch community performance'
    },
    details: {
      title: 'Message Details',
      fetchFailed: 'Failed to fetch message details'
    },
    message: {
      title: 'Messages',
      empty: 'No messages',
      fetchFailed: 'Failed to fetch messages'
    },
    direct: {
      title: 'Direct Performance',
      totalCount: 'Total Count',
      totalAmount: 'Total Amount',
      empty: 'No content',
      directUsers: 'Direct Referrals',
      fetchFailed: 'Failed to fetch direct performance',
      table: {
        address: 'Address',
        level: 'Level',
        amount: 'Amount',
        totalPerf: 'Team Total'
      }
    },
    ranking: {
      title: 'Weekly Ranking',
      poolBalance: 'Weekly Prize Pool',
      poolContract: 'Prize Pool Contract',
      performanceRanking: 'Performance Ranking',
      myRank: 'My Rank',
      weekStartTime: 'Weekly ranking start: ',
      weekEndCountdown: 'Countdown to weekly ranking end',
      fetchFailed: 'Failed to fetch ranking',
      table: {
        rank: 'Rank',
        address: 'Address',
        performance: 'Performance'
      }
    },
    invite: {
      title: 'Invite Friends',
      bannerTitle: 'Invite friends, share rewards',
      bannerLine1: 'For each friend you successfully invite to join a node',
      bannerLine2Prefix: 'You will receive',
      bannerLine2Suffix: 'of their participation amount as a referral reward',
      inviteCode: 'Invite Code',
      myAddress: 'My Address',
      myInviter: 'My Superior',
      inviteLink: 'Invite Link'
    },
    prediction: {
      title: 'EQX Prediction',
      contest: 'Trading Contest',
      pairSub: '1-minute K-line prediction',
      pairTitle: 'BTC/USDT · 1 Minute',
      credit: 'Prediction Gold',
      costPrefix: 'Cost per prediction',
      availableCredit: 'Available Prediction Gold',
      currentScore: 'Current Score',
      claim: 'Claim',
      claiming: 'Claiming...',
      claimMilestone: 'Claim {value}-point reward',
      milestoneNotReached: 'Milestone not reached',
      nextMilestone: 'Next milestone {value}',
      scoreProgress: 'Score Progress',
      predicting: 'Predicting',
      predictCountdown: 'Predict again in {seconds}s',
      ruleText: 'Each prediction costs 100 Prediction Gold · Correct +1 point, wrong -1 point',
      history: 'History',
      emptyHistory: 'No prediction history',
      milestoneReached: 'Milestone Reached',
      stakeCountdownLabel: '◎ Staking · Unlock Countdown',
      noStakeLabel: '◎ No active stake · New stake available',
      submitSuccessWait: 'Submitted successfully. Please check the history below after 1 minute.',
      submitFailed: 'Submit failed',
      claimSuccess: 'Claim successful',
      claimFailed: 'Claim failed',
      historyFetchFailed: 'Failed to fetch prediction history',
      openPrice: 'Open',
      closePrice: 'Close',
      scoreUnit: '{score} pts',
      countdown: {
        days: '{value}d',
        hours: '{value}h',
        minutes: '{value}m'
      },
      direction: {
        up: 'Up',
        down: 'Down'
      },
      status: {
        pending: 'Pending',
        win: 'Correct',
        lose: 'Wrong',
        draw: 'Draw',
        canceled: 'Canceled'
      }
    },
    eqxStake: {
      title: 'EQX Stake',
      stakeUnlock: 'Stake',
      availableBalance: 'Stakeable Balance',
      stakedBalance: 'Staked Balance',
      selectPeriod: 'Select Stake Period',
      recommended: 'Recommended',
      days: '{value}d',
      rules: 'Stake Rules',
      periodStake: '{value}d Stake',
      rateText: '1 EQX → {rate} Prediction Gold',
      principalLocked: 'Principal Locked',
      stakeAmount: 'Stake Amount',
      availableAmount: 'Available',
      maxStakeAmount: 'Max Stake',
      estimatedCredit: 'Estimated Prediction Gold',
      records: 'Stake Records',
      all: 'All',
      periodDesc: {
        shortTerm: 'Short-term stable',
        midTerm: 'Mid-term growth',
        longTerm: 'Long-term best'
      },
      activeStakeError: 'Current stake period has not ended. Re-staking is unavailable.',
      inputAmount: 'Please enter stake amount',
      minAmount: 'Minimum stake is 100 EQX',
      maxOrAvailableError: 'Stake amount cannot exceed max stake or available amount',
      availableError: 'Stake amount cannot exceed available balance',
      submitting: 'Staking on-chain...',
      activeStakeButton: 'Stake period not ended. Re-staking unavailable.',
      confirmStake: 'Confirm Stake · {days}d',
      successTitle: 'Stake Successful',
      failureTitle: 'Stake Failed',
      successDesc: 'Staked {amount} EQX.',
      recordLockedDesc: '{days}d stake · Locked',
      locked: 'Locked',
      maxStakeFetchFailed: 'Failed to fetch max stake amount',
      creditAmount: '{value} Prediction Gold',
      noFee: 'No charge',
      userRejected: 'User rejected wallet signature.',
      insufficientBnb: 'Insufficient BNB balance to send transaction.',
      activeStakeExists: 'This account already has an active stake. Each user can only stake once at a time.',
      tokenNotSet: 'Vault has not configured EQX Token address.',
      detail: {
        contract: 'Contract',
        period: 'Stake Period',
        rate: 'Exchange Rate',
        principal: 'Locked Principal',
        output: 'Estimated Output',
        fee: 'BNB Fee'
      }
    },
    wallet: {
      title: 'Deposit / Withdraw',
      balance: 'Wallet Balance',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      amountLabel: '{action} Amount',
      minHint: 'Minimum {action} 100 EQX',
      depositTip1: 'After deposit, EQX will appear in wallet balance and can be used for staking.',
      depositTip2: 'The fee is determined by network gas and actual deduction.',
      withdrawTip1: 'Withdraw amount will be deducted from wallet balance. Please confirm chain address and network.',
      withdrawTip2: 'Withdrawal fee depends on network gas and actual arrival.',
      inputAmount: 'Please enter amount',
      minAmount: 'Minimum amount is 100 EQX',
      withdrawExceedBalance: 'Withdraw amount cannot exceed wallet balance',
      submitNow: '{action} Now',
      depositing: 'Depositing on-chain...',
      withdrawing: 'Withdrawing on-chain...',
      resultSuccess: '{action} Successful',
      resultFailed: '{action} Failed',
      resultDesc: '{action}ed {amount} EQX. Wallet balance updated.',
      userRejected: 'User rejected wallet signature.',
      invalidFee: 'On-chain fee must be exactly {fee} BNB.',
      insufficientBnb: 'Insufficient BNB. Deposit/withdraw requires extra {fee} BNB fee.',
      withdrawalsPaused: 'Withdrawals are currently paused by contract.',
      tokenNotSet: 'Vault has not configured EQX Token address.',
      receiverNotSet: 'Vault has not configured fee receiver address.',
      detail: {
        contract: 'Contract',
        type: 'Type',
        amount: 'Amount',
        fee: 'BNB Fee',
        balance: 'Current Balance'
      }
    },
    tradeHistory: {
      title: 'Trade History'
    },
    amountDetails: {
      title: 'participation record',
    },
    revenueDetails: {
      title: 'revenue details'
    }
  },
  ko: {
    message: {
      hello: '안녕하세요, 세계'
    },
    common: {
      usdt: 'USDT',
      eqx: 'EQX',
      copy: '복사',
      copied: '복사됨',
      copyFailed: '복사 실패',
      done: '완료',
      stayTuned: '곧 공개됩니다',
      txHash: '트랜잭션 해시',
      txHashEmpty: '트랜잭션 해시가 비어 있습니다',
      installWallet: '지갑 확장 프로그램을 설치하거나 활성화하세요',
      walletNotConnected: '지갑이 연결되지 않았습니다',
      txFailed: '트랜잭션 실패',
      txTimeout: '트랜잭션 확인 시간 초과',
      decimalsInvalid: '잘못된 decimals',
      pleaseLogin: '먼저 로그인하세요',
      accountBanned: '계정이 제한되었습니다',
      back: '뒤로',
      confirm: '확인'
    },
    hashPower: {
      globalLabel: '전체 해시파워',
      myLabel: '내 해시파워',
      stats: {
        nodeCount: '노드 수',
        todayYield: '오늘 수익률',
        totalStaked: '총 스테이킹',
        directPool: '직접 추천 랭킹 풀',
        simGoldPool: '스마트 예측금 풀'
      }
    },
    home: {
      participateNow: '컴퓨팅 파워 구매',
      participatedQuota: '참여 금액',
      walletAvailable: '지갑 잔액',
      remainingQuota: '남은 한도',
      participateAmount: '금액',
      amountRange: '100-10000 USDT',
      maxTitle: '최대 참여 한도에 도달했습니다',
      maxDesc: '참여 금액이 10000U에 도달하면 더 이상 참여할 수 없습니다',
      participateSuccessTitle: '참여 성공',
      participateSuccessSubtitle: '온체인에서 트랜잭션이 확인되었습니다',
      confirmDone: '확인',
      amountMultiple100: '금액은 100의 배수여야 합니다',
      participateFailed: '참여 실패',
      userInfoFailed: '사용자 정보를 불러오지 못했습니다'
    },
    my: {
      nodeTorch: '토치 노드',
      nodeGlory: '글로리 노드',
      totalClaimedUsdt: '누적 수령 USDT',
      remainingExitQuotaUsdt: '남은 출금 한도 USDT',
      totalClaimedEqx: '누적 수령 EQX',
      unclaimedUsdt: '미수령 USDT',
      unclaimedEqx: '미수령 EQX',
      claim: '수령',
      copyInviteLink: '초대 링크 복사',
      receivingAddress: '수령 주소',
      claimAmount: '수령 금액',
      confirmClaim: '수령 확인',
      claimSuccessTitle: '수령 성공',
      claimArrived: '{amount} {token} 입금 완료',
      totalDataFailed: '통계 데이터를 불러오지 못했습니다',
      requestSignFailed: '서명 요청 실패',
      signMissing: '서버 응답에 서명이 없습니다',
      signInvalid: '서명 형식이 올바르지 않습니다',
      noClaimUsdt: '수령 가능한 USDT가 없습니다',
      noClaimEqx: '수령 가능한 EQX가 없습니다',
      eqxPoolTransferable: '이번 분배 풀 전환 가능 수량',
      eqxPoolNextDeposit: '다음 최초 전환',
      eqxPoolDeposit: '분배 풀 전환',
      eqxPoolSection: '분배 풀',
      eqxPoolClaimable: '현재 수령 가능',
      eqxPoolUnreleased: '미출시 수량',
      eqxPoolReleasePerDay: '일일 출시',
      eqxPoolFinalTime: '예상 완료',
      eqxPoolClaimReleased: '출시된 EQX 수령',
      eqxSwitchChain: '지갑을 BSC 네트워크로 전환해 주세요',
      eqxPoolDataError: '분배 풀 데이터 오류',
      eqxPoolPaused: '수령 일시 중지',
      eqxPoolNothing: '수령 가능한 수량 없음',
      eqxPoolAutoCheckpoint: '수령 시 출시 기록이 자동으로 진행됩니다',
      claimFailed: '수령 실패'
    },
    navbar: {
      connectWallet: '지갑 연결',
      connectFailed: '지갑 연결 실패',
      nonceFailed: 'nonce를 가져오지 못했습니다',
      loginFailed: '로그인 실패',
      signLoginFailed: '서명 또는 로그인 실패',
      userInfoFailed: '사용자 정보를 불러오지 못했습니다',
      langEn: 'English',
      langZh: '中文',
      langKo: '한국어',
      langJa: '日本語'
    },
    tab: {
      home: '홈',
      sim: 'Sim',
      my: '내 정보'
    },
    modal: {
      invite: {
        title: '초대 코드 입력',
        placeholder: '초대 코드를 입력하세요',
        formatHint: '형식: 6–12자리 영문/숫자',
        invalidFormat: '형식: 6–12자리 영문/숫자',
        cancel: '취소',
        confirm: '확인',
        noCodeHint: '초대 코드가 없나요? 추천인에게 문의하세요',
        required: '초대 코드는 필수입니다'
      }
    },
    community: {
      title: '커뮤니티 실적',
      macroTitle: '매크로 실적',
      microTitle: '마이크로 실적',
      totalCount: '총 수량',
      totalAmount: '총 금액',
      communityUsers: '커뮤니티 인원',
      activeNodes: '활성 노드',
      fetchFailed: '커뮤니티 실적을 불러오지 못했습니다'
    },
    details: {
      title: '메시지 상세',
      fetchFailed: '메시지 상세를 불러오지 못했습니다'
    },
    message: {
      title: '메시지',
      empty: '메시지가 없습니다',
      fetchFailed: '메시지를 불러오지 못했습니다'
    },
    direct: {
      title: '직접 추천 실적',
      totalCount: '총 수량',
      totalAmount: '총 금액',
      empty: '내용이 없습니다',
      directUsers: '직접 추천 인원',
      fetchFailed: '직접 추천 실적을 불러오지 못했습니다',
      table: {
        address: '주소',
        level: '레벨',
        amount: '금액',
        totalPerf: '팀 총 실적'
      }
    },
    ranking: {
      title: '주간 랭킹',
      poolBalance: '주간 상금 풀',
      poolContract: '상금 풀 컨트랙트',
      performanceRanking: '실적 랭킹',
      myRank: '내 순위',
      weekStartTime: '이번 주 랭킹 시작 시간: ',
      weekEndCountdown: '이번 주 랭킹 종료까지 남은 시간',
      fetchFailed: '랭킹을 불러오지 못했습니다',
      table: {
        rank: '순위',
        address: '주소',
        performance: '실적'
      }
    },
    invite: {
      title: '친구 초대',
      bannerTitle: '친구를 초대하고 보상을 공유하세요',
      bannerLine1: '친구가 컴퓨팅 파워에 참여하도록 초대할 때마다',
      bannerLine2Prefix: '참여 금액의',
      bannerLine2Suffix: '를 초대 보상으로 받습니다',
      inviteCode: '초대 코드',
      myAddress: '내 주소',
      myInviter: '상위 추천인',
      inviteLink: '초대 링크'
    },
    prediction: {
      title: 'EQX 예측',
      contest: '트레이딩 대회',
      pairSub: '1분 K라인 예측',
      pairTitle: 'BTC/USDT · 1분',
      credit: '예측 골드',
      costPrefix: '예측 1회 소모',
      availableCredit: '사용 가능 예측 골드',
      currentScore: '현재 점수',
      claim: '수령',
      claiming: '수령 중...',
      claimMilestone: '{value}점 보상 수령',
      milestoneNotReached: '마일스톤 미달성',
      nextMilestone: '다음 마일스톤 {value}',
      scoreProgress: '점수 진행도',
      predicting: '예측 중',
      predictCountdown: '{seconds}초 후 다시 예측 가능',
      ruleText: '예측 1회마다 예측 골드 100 소모 · 정답 +1점, 오답 -1점',
      history: '기록',
      emptyHistory: '예측 기록이 없습니다',
      milestoneReached: '마일스톤 달성',
      stakeCountdownLabel: '◎ 스테이킹 중 · 잠금해제 카운트다운',
      noStakeLabel: '◎ 진행 중인 스테이킹 없음 · 새 스테이킹 가능',
      submitSuccessWait: '제출 성공. 1분 후 아래 기록을 확인하세요.',
      submitFailed: '제출 실패',
      claimSuccess: '수령 성공',
      claimFailed: '수령 실패',
      historyFetchFailed: '예측 기록을 불러오지 못했습니다',
      openPrice: '진입가',
      closePrice: '청산가',
      scoreUnit: '{score}점',
      countdown: {
        days: '{value}일',
        hours: '{value}시',
        minutes: '{value}분'
      },
      direction: {
        up: '상승',
        down: '하락'
      },
      status: {
        pending: '정산 대기',
        win: '예측 성공',
        lose: '예측 실패',
        draw: '무승부',
        canceled: '취소됨'
      }
    },
    eqxStake: {
      title: 'EQX 스테이킹',
      stakeUnlock: '스테이킹',
      availableBalance: '스테이킹 가능 잔액',
      stakedBalance: '스테이킹 잔액',
      selectPeriod: '스테이킹 기간 선택',
      recommended: '추천',
      days: '{value}일',
      rules: '스테이킹 규칙',
      periodStake: '{value}일 스테이킹',
      rateText: '1 EQX → {rate} 예측 골드',
      principalLocked: '원금 잠금',
      stakeAmount: '스테이킹 수량',
      availableAmount: '사용 가능',
      maxStakeAmount: '최대 스테이킹',
      estimatedCredit: '예상 예측 골드',
      records: '스테이킹 기록',
      all: '전체',
      periodDesc: {
        shortTerm: '단기 안정',
        midTerm: '중기 성장',
        longTerm: '장기 최적'
      },
      activeStakeError: '현재 스테이킹 기간이 종료되지 않아 중복 스테이킹할 수 없습니다',
      inputAmount: '스테이킹 수량을 입력하세요',
      minAmount: '최소 스테이킹은 100 EQX입니다',
      maxOrAvailableError: '스테이킹 수량은 최대 스테이킹 또는 사용 가능 수량을 초과할 수 없습니다',
      availableError: '스테이킹 수량은 사용 가능 잔액을 초과할 수 없습니다',
      submitting: '온체인 스테이킹 중...',
      activeStakeButton: '스테이킹 기간 미종료, 중복 스테이킹 불가',
      confirmStake: '스테이킹 확인 · {days}일',
      successTitle: '스테이킹 성공',
      failureTitle: '스테이킹 실패',
      successDesc: '{amount} EQX 스테이킹 완료.',
      recordLockedDesc: '{days}일 스테이킹 · 잠금 중',
      locked: '잠금 중',
      maxStakeFetchFailed: '최대 스테이킹 수량을 불러오지 못했습니다',
      creditAmount: '{value} 예측 골드',
      noFee: '수수료 없음',
      userRejected: '사용자가 지갑 서명을 취소했습니다.',
      insufficientBnb: 'BNB 잔액이 부족하여 거래를 보낼 수 없습니다.',
      activeStakeExists: '현재 계정에 만료되지 않은 스테이킹이 있습니다. 동시에 한 번만 스테이킹할 수 있습니다.',
      tokenNotSet: 'Vault에 EQX Token 주소가 설정되지 않았습니다.',
      detail: {
        contract: '컨트랙트',
        period: '스테이킹 기간',
        rate: '교환 비율',
        principal: '잠금 원금',
        output: '예상 산출',
        fee: 'BNB 수수료'
      }
    },
    wallet: {
      title: '입금 / 출금',
      balance: '지갑 잔액',
      deposit: '입금',
      withdraw: '출금',
      amountLabel: '{action} 수량',
      minHint: '최소 {action} 100 EQX',
      depositTip1: '입금 후 EQX는 지갑 잔액에 표시되며 스테이킹에 사용할 수 있습니다.',
      depositTip2: '수수료는 네트워크 가스에 따라 실제 차감됩니다.',
      withdrawTip1: '출금 수량은 지갑 잔액에서 차감됩니다. 주소와 네트워크를 확인하세요.',
      withdrawTip2: '출금 수수료는 네트워크 가스와 실제 도착 기준입니다.',
      inputAmount: '수량을 입력하세요',
      minAmount: '최소 수량은 100 EQX입니다',
      withdrawExceedBalance: '출금 수량은 지갑 잔액을 초과할 수 없습니다',
      submitNow: '지금 {action}',
      depositing: '온체인 입금 중...',
      withdrawing: '온체인 출금 중...',
      resultSuccess: '{action} 성공',
      resultFailed: '{action} 실패',
      resultDesc: '{amount} EQX {action} 완료, 지갑 잔액이 업데이트되었습니다.',
      userRejected: '사용자가 지갑 서명을 취소했습니다.',
      invalidFee: '온체인 수수료는 정확히 {fee} BNB여야 합니다.',
      insufficientBnb: 'BNB 잔액이 부족합니다. 입금/출금에는 추가 {fee} BNB 수수료가 필요합니다.',
      withdrawalsPaused: '현재 컨트랙트 출금이 일시 중지되었습니다.',
      tokenNotSet: 'Vault에 EQX Token 주소가 설정되지 않았습니다.',
      receiverNotSet: 'Vault에 수수료 수신 주소가 설정되지 않았습니다.',
      detail: {
        contract: '컨트랙트',
        type: '유형',
        amount: '수량',
        fee: 'BNB 수수료',
        balance: '현재 잔액'
      }
    },
    tradeHistory: {
      title: '거래 기록'
    },
    amountDetails: {
      title: '참여 기록'
    },
    revenueDetails: {
      title: '수익 상세'
    }
  },
  ja: {
    message: {
      hello: 'こんにちは、世界'
    },
    common: {
      usdt: 'USDT',
      eqx: 'EQX',
      copy: 'コピー',
      copied: 'コピーしました',
      copyFailed: 'コピーに失敗しました',
      done: '完了',
      stayTuned: '近日公開',
      txHash: 'トランザクションハッシュ',
      txHashEmpty: 'トランザクションハッシュが空です',
      installWallet: 'ウォレット拡張機能をインストールまたは有効化してください',
      walletNotConnected: 'ウォレットが接続されていません',
      txFailed: 'トランザクション失敗',
      txTimeout: 'トランザクション確認がタイムアウトしました',
      decimalsInvalid: 'decimals が無効です',
      pleaseLogin: '先にログインしてください',
      accountBanned: 'アカウントが制限されています',
      back: '戻る',
      confirm: '確認'
    },
    hashPower: {
      globalLabel: '全体ハッシュパワー',
      myLabel: '自分のハッシュパワー',
      stats: {
        nodeCount: 'ノード数',
        todayYield: '本日の利回り',
        totalStaked: '総ステーキング',
        directPool: '直接紹介ランキングプール',
        simGoldPool: 'スマート予測金プール'
      }
    },
    home: {
      participateNow: '計算力を購入',
      participatedQuota: '参加済み',
      walletAvailable: 'ウォレット残高',
      remainingQuota: '残り枠',
      participateAmount: '金額',
      amountRange: '100-10000 USDT',
      maxTitle: '最大参加枠に達しました',
      maxDesc: '参加金額が 10000U に達すると、これ以上参加できません',
      participateSuccessTitle: '参加成功',
      participateSuccessSubtitle: 'トランザクションがオンチェーンで確認されました',
      confirmDone: '確認',
      amountMultiple100: '金額は100の倍数である必要があります',
      participateFailed: '参加に失敗しました',
      userInfoFailed: 'ユーザー情報の取得に失敗しました'
    },
    my: {
      nodeTorch: 'トーチノード',
      nodeGlory: 'グローリーノード',
      totalClaimedUsdt: '累計受取 USDT',
      remainingExitQuotaUsdt: '残り出金枠 USDT',
      totalClaimedEqx: '累計受取 EQX',
      unclaimedUsdt: '未受取 USDT',
      unclaimedEqx: '未受取 EQX',
      claim: '受取',
      copyInviteLink: '招待リンクをコピー',
      receivingAddress: '受取アドレス',
      claimAmount: '受取金額',
      confirmClaim: '受取を確認',
      claimSuccessTitle: '受取成功',
      claimArrived: '{amount} {token} が着金しました',
      totalDataFailed: '統計データの取得に失敗しました',
      requestSignFailed: '署名の要求に失敗しました',
      signMissing: 'サーバー応答に署名がありません',
      signInvalid: '署名形式が正しくありません',
      noClaimUsdt: '受取可能なUSDTがありません',
      noClaimEqx: '受取可能なEQXがありません',
      eqxPoolTransferable: '今回プールへ移行可能数量',
      eqxPoolNextDeposit: '次回最速移行',
      eqxPoolDeposit: 'プールへ移行',
      eqxPoolSection: 'プール',
      eqxPoolClaimable: '現在受取可能',
      eqxPoolUnreleased: '未リリース',
      eqxPoolReleasePerDay: '毎日リリース',
      eqxPoolFinalTime: '完了予定',
      eqxPoolClaimReleased: 'リリース済みEQXを受取',
      eqxSwitchChain: 'ウォレットをBSCネットワークに切り替えてください',
      eqxPoolDataError: 'プールデータエラー',
      eqxPoolPaused: '受取が一時停止されています',
      eqxPoolNothing: '受取可能な数量がありません',
      eqxPoolAutoCheckpoint: '受取時にリリース記録が自動で進行します',
      claimFailed: '受取に失敗しました'
    },
    navbar: {
      connectWallet: 'ウォレット接続',
      connectFailed: 'ウォレット接続に失敗しました',
      nonceFailed: 'nonce の取得に失敗しました',
      loginFailed: 'ログインに失敗しました',
      signLoginFailed: '署名またはログインに失敗しました',
      userInfoFailed: 'ユーザー情報の取得に失敗しました',
      langEn: 'English',
      langZh: '中文',
      langKo: '한국어',
      langJa: '日本語'
    },
    tab: {
      home: 'ホーム',
      sim: 'Sim',
      my: 'マイ'
    },
    modal: {
      invite: {
        title: '招待コードを入力',
        placeholder: '招待コードを入力してください',
        formatHint: '形式: 6–12 文字の英数字',
        invalidFormat: '形式: 6–12 文字の英数字',
        cancel: 'キャンセル',
        confirm: '確認',
        noCodeHint: '招待コードがありませんか？紹介者に連絡してください',
        required: '招待コードは必須です'
      }
    },
    community: {
      title: 'コミュニティ実績',
      macroTitle: 'マクロ実績',
      microTitle: 'ミクロ実績',
      totalCount: '総数',
      totalAmount: '総額',
      communityUsers: 'コミュニティ人数',
      activeNodes: 'アクティブノード',
      fetchFailed: 'コミュニティ実績の取得に失敗しました'
    },
    details: {
      title: 'メッセージ詳細',
      fetchFailed: 'メッセージ詳細の取得に失敗しました'
    },
    message: {
      title: 'メッセージ',
      empty: 'メッセージはありません',
      fetchFailed: 'メッセージの取得に失敗しました'
    },
    direct: {
      title: '直紹介実績',
      totalCount: '総数',
      totalAmount: '総額',
      empty: '内容がありません',
      directUsers: '直紹介人数',
      fetchFailed: '直紹介実績の取得に失敗しました',
      table: {
        address: 'アドレス',
        level: 'レベル',
        amount: '金額',
        totalPerf: 'チーム合計'
      }
    },
    ranking: {
      title: '週間ランキング',
      poolBalance: '週間プール',
      poolContract: 'プールコントラクト',
      performanceRanking: '実績ランキング',
      myRank: '自分の順位',
      weekStartTime: '今週ランキング開始: ',
      weekEndCountdown: '今週ランキング終了までのカウントダウン',
      fetchFailed: 'ランキングの取得に失敗しました',
      table: {
        rank: '順位',
        address: 'アドレス',
        performance: '実績'
      }
    },
    invite: {
      title: '友達を招待',
      bannerTitle: '友達を招待して報酬を共有',
      bannerLine1: '友達が計算力に参加するよう招待するたびに',
      bannerLine2Prefix: '参加金額の',
      bannerLine2Suffix: 'を招待報酬として受け取れます',
      inviteCode: '招待コード',
      myAddress: '自分のアドレス',
      myInviter: '上位紹介者',
      inviteLink: '招待リンク'
    },
    prediction: {
      title: 'EQX予測',
      contest: '取引コンテスト',
      pairSub: '1分足Kライン予測',
      pairTitle: 'BTC/USDT · 1分',
      credit: '予測ゴールド',
      costPrefix: '1回あたり消費',
      availableCredit: '利用可能な予測ゴールド',
      currentScore: '現在のスコア',
      claim: '受取',
      claiming: '受取中...',
      claimMilestone: '{value}点報酬を受取',
      milestoneNotReached: 'マイルストーン未達成',
      nextMilestone: '次のマイルストーン {value}',
      scoreProgress: 'スコア進捗',
      predicting: '予測中',
      predictCountdown: '{seconds}秒後に再予測可能',
      ruleText: '各予測は100予測ゴールドを消費 · 正解+1点、不正解-1点',
      history: '履歴',
      emptyHistory: '予測履歴はありません',
      milestoneReached: 'マイルストーン達成',
      stakeCountdownLabel: '◎ ステーキング中 · アンロックまで',
      noStakeLabel: '◎ 進行中のステーキングなし · 新規ステーキング可能',
      submitSuccessWait: '送信成功。1分後に下の履歴を確認してください。',
      submitFailed: '送信に失敗しました',
      claimSuccess: '受取成功',
      claimFailed: '受取に失敗しました',
      historyFetchFailed: '予測履歴の取得に失敗しました',
      openPrice: '始値',
      closePrice: '終値',
      scoreUnit: '{score}点',
      countdown: {
        days: '{value}日',
        hours: '{value}時',
        minutes: '{value}分'
      },
      direction: {
        up: '上昇',
        down: '下落'
      },
      status: {
        pending: '決済待ち',
        win: '予測成功',
        lose: '予測失敗',
        draw: '引き分け',
        canceled: 'キャンセル済み'
      }
    },
    eqxStake: {
      title: 'EQXステーキング',
      stakeUnlock: 'ステーク',
      availableBalance: 'ステーク可能残高',
      stakedBalance: 'ステーク済み残高',
      selectPeriod: 'ステーク期間を選択',
      recommended: 'おすすめ',
      days: '{value}日',
      rules: 'ステークルール',
      periodStake: '{value}日ステーク',
      rateText: '1 EQX → {rate} 予測ゴールド',
      principalLocked: '元本ロック',
      stakeAmount: 'ステーク数量',
      availableAmount: '利用可能',
      maxStakeAmount: '最大ステーク',
      estimatedCredit: '予想予測ゴールド',
      records: 'ステーク記録',
      all: '全て',
      periodDesc: {
        shortTerm: '短期安定',
        midTerm: '中期成長',
        longTerm: '長期最適'
      },
      activeStakeError: '現在のステーク期間が終了していないため、再ステークできません',
      inputAmount: 'ステーク数量を入力してください',
      minAmount: '最小ステークは100 EQXです',
      maxOrAvailableError: 'ステーク数量は最大ステークまたは利用可能数量を超えられません',
      availableError: 'ステーク数量は利用可能残高を超えられません',
      submitting: 'オンチェーンでステーク中...',
      activeStakeButton: 'ステーク期間未終了、再ステーク不可',
      confirmStake: 'ステーク確認 · {days}日',
      successTitle: 'ステーク成功',
      failureTitle: 'ステーク失敗',
      successDesc: '{amount} EQX をステークしました。',
      recordLockedDesc: '{days}日ステーク · ロック中',
      locked: 'ロック中',
      maxStakeFetchFailed: '最大ステーク数量の取得に失敗しました',
      creditAmount: '{value} 予測ゴールド',
      noFee: '手数料なし',
      userRejected: 'ユーザーがウォレット署名をキャンセルしました。',
      insufficientBnb: 'BNB残高不足のため取引を送信できません。',
      activeStakeExists: 'このアカウントには未満期のステークがあります。同時に1回のみステークできます。',
      tokenNotSet: 'VaultにEQX Tokenアドレスが設定されていません。',
      detail: {
        contract: 'コントラクト',
        period: 'ステーク期間',
        rate: '交換比率',
        principal: 'ロック元本',
        output: '予想産出',
        fee: 'BNB手数料'
      }
    },
    wallet: {
      title: '入金 / 出金',
      balance: 'ウォレット残高',
      deposit: '入金',
      withdraw: '出金',
      amountLabel: '{action}数量',
      minHint: '最小{action} 100 EQX',
      depositTip1: '入金後、EQXはウォレット残高に表示され、ステーキングに使用できます。',
      depositTip2: '手数料はネットワークガスにより実際の控除額に従います。',
      withdrawTip1: '出金数量はウォレット残高から差し引かれます。アドレスとネットワークを確認してください。',
      withdrawTip2: '出金手数料はネットワークガスと実際の着金に従います。',
      inputAmount: '数量を入力してください',
      minAmount: '最小数量は100 EQXです',
      withdrawExceedBalance: '出金数量はウォレット残高を超えられません',
      submitNow: '今すぐ{action}',
      depositing: 'オンチェーン入金中...',
      withdrawing: 'オンチェーン出金中...',
      resultSuccess: '{action}成功',
      resultFailed: '{action}失敗',
      resultDesc: '{amount} EQX の{action}が完了し、ウォレット残高が更新されました。',
      userRejected: 'ユーザーがウォレット署名をキャンセルしました。',
      invalidFee: 'オンチェーン手数料は正確に {fee} BNB である必要があります。',
      insufficientBnb: 'BNB残高不足です。入金/出金には追加で {fee} BNB 手数料が必要です。',
      withdrawalsPaused: '現在コントラクトの出金は一時停止されています。',
      tokenNotSet: 'VaultにEQX Tokenアドレスが設定されていません。',
      receiverNotSet: 'Vaultに手数料受取アドレスが設定されていません。',
      detail: {
        contract: 'コントラクト',
        type: 'タイプ',
        amount: '数量',
        fee: 'BNB手数料',
        balance: '現在残高'
      }
    },
    tradeHistory: {
      title: '取引履歴'
    },
    amountDetails: {
      title: '参加記録'
    },
    revenueDetails: {
      title: '収益明細'
    }
  },
  zh: {
    message: {
      hello: '你好，世界'
    },
    common: {
      usdt: 'USDT',
      eqx: 'EQX',
      stayTuned: '敬請期待',
      copy: '複製',
      copied: '已複製',
      copyFailed: '複製失敗',
      done: '完成',
      txHash: '交易哈希',
      txHashEmpty: '交易哈希為空',
      installWallet: '請安裝或開啟錢包擴展',
      walletNotConnected: '錢包未連接',
      txFailed: '交易執行失敗',
      txTimeout: '交易確認超時',
      decimalsInvalid: 'decimals 无效',
      pleaseLogin: '請先登入',
      accountBanned: '帳號受限',
      back: '返回',
      confirm: '確認'
    },
    hashPower: {
      globalLabel: '全網算力',
      myLabel: '我的算力',
      stats: {
        nodeCount: '節點總數',
        todayYield: '今日收益',
        totalStaked: '質押總量',
        directPool: '直推榜獎池',
        simGoldPool: '智測金獎池'
      }
    },
    home: {
      participateNow: '購買算力',
      participatedQuota: '已參與額度',
      walletAvailable: '錢包可用',
      remainingQuota: '剩餘參與額度',
      participateAmount: '參與金額',
      amountRange: '100-10000 USDT',
      maxTitle: '您已達到最大參與額度',
      maxDesc: '參與金額達到 10000U，則不能再參與',
      participateSuccessTitle: '參與成功',
      participateSuccessSubtitle: '交易已上鏈確認',
      confirmDone: '確認完成',
      amountMultiple100: '參與金額只能輸入100的倍數',
      participateFailed: '參與失敗',
      userInfoFailed: '獲取用戶資訊失敗'
    },
    my: {
      nodeTorch: '火炬節點',
      nodeGlory: '榮耀節點',
      totalClaimedUsdt: '累計領取USDT',
      remainingExitQuotaUsdt: '剩餘退出額度USDT',
      totalClaimedEqx: '累計領取EQX',
      unclaimedUsdt: '未領取USDT',
      unclaimedEqx: '未領取EQX',
      claim: '領取',
      copyInviteLink: '複製邀請連結',
      receivingAddress: '到帳地址',
      claimAmount: '領取金額',
      confirmClaim: '確認領取',
      claimSuccessTitle: '領取成功',
      claimArrived: '{amount} {token} 交易已到帳',
      totalDataFailed: '獲取用戶統計資料失敗',
      requestSignFailed: '請求簽名失敗',
      signMissing: '後端未返回簽名',
      signInvalid: '簽名格式不正確',
      noClaimUsdt: '暫無可領取USDT',
      noClaimEqx: '暫無可領取EQX',
      eqxPoolTransferable: '本次可轉入分流池數量',
      eqxPoolNextDeposit: '下次最早轉入',
      eqxPoolDeposit: '轉入分流池',
      eqxPoolSection: '分流池',
      eqxPoolClaimable: '當前可領取',
      eqxPoolUnreleased: '待釋放',
      eqxPoolReleasePerDay: '每日釋放',
      eqxPoolFinalTime: '預計完成',
      eqxPoolClaimReleased: '領取已釋放 EQX',
      eqxSwitchChain: '請將錢包切換到 BSC 主網',
      eqxPoolDataError: '分流池數據異常',
      eqxPoolPaused: '領取已暫停',
      eqxPoolNothing: '暫無可領取 EQX',
      eqxPoolAutoCheckpoint: '領取時將自動推進釋放記錄',
      claimFailed: '領取失敗'
    },
    navbar: {
      connectWallet: '連接錢包',
      connectFailed: '連接錢包失敗',
      nonceFailed: '獲取nonce失敗',
      loginFailed: '登入失敗',
      signLoginFailed: '簽名或登入失敗',
      userInfoFailed: '獲取用戶資訊失敗',
      langEn: 'English',
      langZh: '中文',
      langKo: '한국어',
      langJa: '日本語'
    },
    tab: {
      home: '首頁',
      sim: '智测金',
      my: '我的'
    },
    modal: {
      invite: {
        title: '輸入邀請碼',
        placeholder: '請輸入邀請碼',
        formatHint: '格式：6-12位元字母或資料',
        invalidFormat: '格式：6-12位元字母或資料',
        cancel: '取消',
        confirm: '確認',
        noCodeHint: '沒有邀請碼？請聯絡推薦人',
        required: '邀請碼為必填'
      }
    },
    community: {
      title: '社區業績',
      macroTitle: '宏觀業績',
      microTitle: '微觀業績',
      totalCount: '總數量',
      totalAmount: '總金額',
      communityUsers: '社區人數',
      activeNodes: '活躍節點',
      fetchFailed: '獲取社區業績失敗'
    },
    details: {
      title: '訊息詳情',
      fetchFailed: '獲取訊息詳情失敗'
    },
    message: {
      title: '訊息通知',
      empty: '暫無訊息內容',
      fetchFailed: '獲取訊息列表失敗'
    },
    direct: {
      title: '直推業績',
      totalCount: '總數量',
      totalAmount: '總金額',
      directUsers: '直推人數',
      empty: '暫無內容',
      fetchFailed: '獲取直推業績失敗',
      table: {
        address: '地址',
        level: '級別',
        amount: '金額',
        totalPerf: '總業績'
      }
    },
    ranking: {
      title: '社區貢獻·週排行',
      poolBalance: '本週獎池',
      poolContract: '獎池合約地址',
      performanceRanking: '業績排行',
      myRank: '我的排名',
      weekStartTime: '本週排行開始時間：',
      weekEndCountdown: '距離本週排行結束倒計時',
      fetchFailed: '獲取排行榜失敗',
      table: {
        rank: '名次',
        address: '地址',
        performance: '業績'
      }
    },
    invite: {
      title: '邀請好友',
      bannerTitle: '邀請好友，共享收益',
      bannerLine1: '每成功邀請一位好友參與算力',
      bannerLine2Prefix: '您將獲得其參與金額的',
      bannerLine2Suffix: '作為邀請獎勵',
      inviteCode: '邀請碼',
      myAddress: '我的地址',
      myInviter: '我的上級',
      inviteLink: '邀請連結'
    },
    prediction: {
      title: 'EQX預測',
      contest: '交易賽',
      pairSub: '1分鐘 K線預測',
      pairTitle: 'BTC/USDT · 1分鐘',
      credit: '智測金',
      costPrefix: '每次消耗',
      availableCredit: '可用智測金',
      currentScore: '當前積分',
      claim: '領取',
      claiming: '領取中...',
      claimMilestone: '領取 {value} 分獎勵',
      milestoneNotReached: '未達到里程碑',
      nextMilestone: '下一里程碑 {value}',
      scoreProgress: '積分進度',
      predicting: '預測中',
      predictCountdown: '{seconds}秒後可再次預測',
      ruleText: '每次預測消耗 100 智測金 · 預測正確+1分，錯誤-1分',
      history: '歷史',
      emptyHistory: '暫無預測歷史',
      milestoneReached: '里程碑達成',
      stakeCountdownLabel: '◎ 質押中 · 解押倒計時',
      noStakeLabel: '◎ 暫無質押中 · 可發起新質押',
      submitSuccessWait: '提交成功，請等待1分鐘後查看下方歷史記錄',
      submitFailed: '提交失敗',
      claimSuccess: '領取成功',
      claimFailed: '領取失敗',
      historyFetchFailed: '獲取預測歷史失敗',
      openPrice: '開倉價',
      closePrice: '平倉價',
      scoreUnit: '{score}分',
      countdown: {
        days: '{value}天',
        hours: '{value}時',
        minutes: '{value}分'
      },
      direction: {
        up: '漲',
        down: '跌'
      },
      status: {
        pending: '待結算',
        win: '預測正確',
        lose: '預測錯誤',
        draw: '平局',
        canceled: '已取消'
      }
    },
    eqxStake: {
      title: 'EQX 質押',
      stakeUnlock: '質押',
      availableBalance: '可質押餘額',
      stakedBalance: '已質押餘額',
      selectPeriod: '選擇質押週期',
      recommended: '推薦',
      days: '{value}天',
      rules: '質押規則',
      periodStake: '{value}天 質押',
      rateText: '1 EQX → {rate} 智測金',
      principalLocked: '本金鎖定',
      stakeAmount: '質押數量',
      availableAmount: '可用數量',
      maxStakeAmount: '最大質押數量',
      estimatedCredit: '預計獲得智測金',
      records: '質押記錄',
      all: '全部',
      periodDesc: {
        shortTerm: '短期穩健',
        midTerm: '中期增益',
        longTerm: '長期最優'
      },
      activeStakeError: '當前質押週期未結束，暫不可重複質押',
      inputAmount: '請輸入質押數量',
      minAmount: '最低質押 100 EQX',
      maxOrAvailableError: '質押數量不能超過最大質押數量或可用數量',
      availableError: '質押數量不能超過可用餘額',
      submitting: '鏈上質押中...',
      activeStakeButton: '質押週期未結束，暫不可重複質押',
      confirmStake: '確認質押 · {days}天',
      successTitle: '質押成功',
      failureTitle: '質押失敗',
      successDesc: '已質押 {amount} EQX。',
      recordLockedDesc: '{days}天質押 · 鎖定中',
      locked: '鎖定中',
      maxStakeFetchFailed: '獲取最大質押數量失敗',
      creditAmount: '{value} 智測金',
      noFee: '不收取',
      userRejected: '用戶取消了錢包簽名。',
      insufficientBnb: 'BNB 餘額不足，無法發起交易。',
      activeStakeExists: '當前帳戶已有一筆未到期質押，每個用戶同一時間只能質押一次。',
      tokenNotSet: 'Vault 還未配置 EQX Token 地址。',
      detail: {
        contract: '合約',
        period: '質押週期',
        rate: '兌換比例',
        principal: '鎖定本金',
        output: '預計產出',
        fee: 'BNB 手續費'
      }
    },
    wallet: {
      title: '充值 / 提幣',
      balance: '錢包餘額',
      deposit: '充值',
      withdraw: '提幣',
      amountLabel: '{action}數量',
      minHint: '最低{action} 100 EQX',
      depositTip1: '充值後 EQX 將顯示在錢包餘額中，可用於質押獲取智測金。',
      depositTip2: '手續費由網路礦工費決定，具體以實際扣除為準。',
      withdrawTip1: '提幣數量將從錢包餘額中扣除，請確認鏈上地址與網路一致。',
      withdrawTip2: '提幣手續費由網路礦工費決定，具體以實際到帳為準。',
      inputAmount: '請輸入數量',
      minAmount: '最低數量為 100 EQX',
      withdrawExceedBalance: '提幣數量不能超過錢包餘額',
      submitNow: '立即{action}',
      depositing: '鏈上充值中...',
      withdrawing: '鏈上提幣中...',
      resultSuccess: '{action}成功',
      resultFailed: '{action}失敗',
      resultDesc: '已{action} {amount} EQX，錢包餘額已更新。',
      userRejected: '用戶取消了錢包簽名。',
      invalidFee: '鏈上手續費必須精確為 {fee} BNB。',
      insufficientBnb: 'BNB 餘額不足，充值/提幣需要額外支付 {fee} BNB 手續費。',
      withdrawalsPaused: '當前合約已暫停提幣。',
      tokenNotSet: 'Vault 還未配置 EQX Token 地址。',
      receiverNotSet: 'Vault 還未配置手續費接收地址。',
      detail: {
        contract: '合約',
        type: '類型',
        amount: '數量',
        fee: 'BNB 手續費',
        balance: '當前餘額'
      }
    },
    tradeHistory: {
      title: '交易歷史'
    },
    amountDetails: {
      title: '參與記錄',
    },
    revenueDetails: {
      title: '收益明細'
    }
  }
}

const i18n = new VueI18n({
  locale: (typeof window !== 'undefined' && window.localStorage && window.localStorage.getItem('lang')) || 'en', // set locale
  messages // set locale messages
})

export default i18n
